import axios from 'axios'
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster'

import { cleanEntity } from '../../utils/entity-utils'
import { FAILURE, REQUEST, SUCCESS } from '../../shared/reducers/action-type.util'

import { defaultValue, ITournament } from '../../shared/model/tournament.model'

export const ACTION_TYPES = {
  FETCH_RUNNINGTOURNAMENT_LIST: 'tournamentMatch/FETCH_RUNNINGTOURNAMENT_LIST',
  FETCH_RUNNINGTOURNAMENT: 'tournamentMatch/FETCH_RUNNINGTOURNAMENT',
  UPDATE_RUNNINGTOURNAMENT: 'tournamentMatch/UPDATE_RUNNINGTOURNAMENT',
}

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ITournament>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
}

export type TournamentsRunningState = Readonly<typeof initialState>;

// Reducer

export default (state: TournamentsRunningState = initialState, action): TournamentsRunningState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_RUNNINGTOURNAMENT_LIST):
    case REQUEST(ACTION_TYPES.FETCH_RUNNINGTOURNAMENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      }
    case REQUEST(ACTION_TYPES.UPDATE_RUNNINGTOURNAMENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      }
    case FAILURE(ACTION_TYPES.FETCH_RUNNINGTOURNAMENT_LIST):
    case FAILURE(ACTION_TYPES.FETCH_RUNNINGTOURNAMENT):
    case FAILURE(ACTION_TYPES.UPDATE_RUNNINGTOURNAMENT):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      }
    case SUCCESS(ACTION_TYPES.FETCH_RUNNINGTOURNAMENT_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      }
    case SUCCESS(ACTION_TYPES.FETCH_RUNNINGTOURNAMENT):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      }
    case SUCCESS(ACTION_TYPES.UPDATE_RUNNINGTOURNAMENT):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      }
    default:
      return state
  }
};

const apiUrl = 'api/management/running-tournaments'

// Actions
export const getEntities: ICrudGetAllAction<ITournament> = (page, size, sort, filters?: {}) => {
  let requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`
  if (filters) {
    if (filters['eventId']) {
      requestUrl += `${requestUrl.indexOf('?')>=0?'&':'?'}eventId.in=${filters['eventId'].join('&eventId.in=')}`
    }
    if (filters['categoryId']) {
      requestUrl += `${requestUrl.indexOf('?')>=0?'&':'?'}tournamentCategoryId.in=${filters['categoryId'].join('&tournamentCategoryId.in=')}`
    }
    if (filters['disciplineId']) {
      requestUrl += `${requestUrl.indexOf('?')>=0?'&':'?'}disciplineId.in=${filters['disciplineId'].join('&disciplineId.in=')}`
    }
    if (filters['tournamentName']) {
      requestUrl += `${requestUrl.indexOf('?')>=0?'&':'?'}tournamentName.contains=${filters['tournamentName']}`
    }
  }
  return {
    type: ACTION_TYPES.FETCH_RUNNINGTOURNAMENT_LIST,
    payload: axios.get<ITournament>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  }
}

export const getEntity: ICrudGetAction<ITournament> = id => {
  const requestUrl = `${apiUrl}/${id}`
  return {
    type: ACTION_TYPES.FETCH_RUNNINGTOURNAMENT,
    payload: axios.get<ITournament>(requestUrl),
  }
}

export const updateEntity: ICrudPutAction<ITournament> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_RUNNINGTOURNAMENT,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  })
  dispatch(getEntities())
  return result
}
